import { tokens } from 'src/design-system';
import { commonStyles } from 'src/Library/CommonStyles';

export const SEQuoteCardStyles = (theme) => ({
  cardDiv: {
    width: '100%',
    marginBottom: tokens.spacing.ms,
    border: `1px solid ${tokens.colors.border}`,
    borderRadius: tokens.radius.md,
    backgroundColor: tokens.colors.bgWhite,
  },
  cardBody: {
    padding: `${tokens.spacing.md}px ${tokens.spacing.ms}px`,
    display: 'flex',
    alignItems: 'center',
  },
  cardBodyColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: tokens.spacing.xs,
    padding: `0 ${tokens.spacing.md}px`,
  },
  columnBorderLeft: {
    borderLeft: `1px solid ${tokens.colors.border}`,
  },
  orgName: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: 1.4,
    ...commonStyles(theme).ellipses,
  },
  label: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
    lineHeight: 1.4,
  },
  value: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.regular,
    lineHeight: 1.4,
  },
  boldPrice: {
    fontSize: tokens.fontSize.h1,
    color: tokens.colors.textSecondary,
    fontWeight: tokens.fontWeight.bold,
    lineHeight: 1.4,
  },
  deviation: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
    marginTop: tokens.spacing.lg,
    lineHeight: 1.4,
  },
  referenceCard: {
    opacity: 0.7,
  },
  bottomDiv: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: tokens.colors.bgSubtle,
    borderRadius: `0 0 ${tokens.radius.md}px ${tokens.radius.md}px`,
    padding: `${tokens.spacing.sm}px ${tokens.spacing.md}px`,
  },
  bottomContent: {
    color: tokens.colors.textSecondary,
    fontSize: tokens.fontSize.caption,
    ...commonStyles(theme).ellipses,
  },
});
